$(document).ready(function () {
  console.log('Carousel initialized');

  $('#shopify-section-template--24666179109146__91de7cdd-a05f-4579-853d-91337c6a3066 .featured-grid--root .featured-grid--body').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});
